export default "__VITE_ASSET__CB862vaj__"